import React from 'react';
import type { SignatureVerdict } from '../utils/signatureQuality';

export interface SignatureQualityNoticeTexts {
    signatureCaptured: string;
    signatureHint: string;
    signatureTooSimple: string;
    signatureLooksSimple: string;
    signatureConfirmedNote: string;
    signAgain: string;
    confirmUsualSignature: string;
}

interface Props {
    verdict: SignatureVerdict;
    /** The guest confirmed this exact drawing as their usual signature. */
    confirmed: boolean;
    texts: SignatureQualityNoticeTexts;
    onSignAgain: () => void;
    onConfirm: () => void;
}

const box: React.CSSProperties = {
    marginTop: 8, padding: '10px 14px', background: '#fffaf0', border: '1px solid #fbd38d',
    borderRadius: 8, fontSize: '0.875rem', color: '#975a16',
};
const actions: React.CSSProperties = { display: 'flex', gap: 8, marginTop: 8, flexWrap: 'wrap' };

/**
 * What the guest reads under the signature box. A dot offers only "Sign again"; a straight line
 * also offers an explicit confirmation. Nothing here ever clears or confirms by itself.
 */
const SignatureQualityNotice: React.FC<Props> = ({ verdict, confirmed, texts, onSignAgain, onConfirm }) => {
    if (verdict === 'EMPTY') {
        return <div style={{ fontSize: '0.85rem', color: '#4a5568', marginTop: 6 }}>{texts.signatureHint}</div>;
    }
    if (verdict === 'OK') {
        return <div style={{ fontSize: '0.85rem', color: '#4a5568', marginTop: 6 }}>{texts.signatureCaptured}</div>;
    }
    if (verdict === 'STRAIGHT' && confirmed) {
        return (
            <div style={{ fontSize: '0.85rem', color: '#4a5568', marginTop: 6 }}>
                {texts.signatureConfirmedNote}{' '}
                <button type="button" className="btn btn-sm btn-muted" style={{ padding: '2px 8px' }} onClick={onSignAgain}>
                    {texts.signAgain}
                </button>
            </div>
        );
    }
    if (verdict === 'STRAIGHT') {
        return (
            <div role="alert" style={box}>
                <div>{texts.signatureLooksSimple}</div>
                <div style={actions}>
                    <button type="button" className="btn btn-sm btn-muted" onClick={onSignAgain}>{texts.signAgain}</button>
                    <button type="button" className="btn btn-sm btn-primary" onClick={onConfirm}>{texts.confirmUsualSignature}</button>
                </div>
            </div>
        );
    }
    return (
        <div role="alert" style={box}>
            <div>{texts.signatureTooSimple}</div>
            <div style={actions}>
                <button type="button" className="btn btn-sm btn-primary" onClick={onSignAgain}>{texts.signAgain}</button>
            </div>
        </div>
    );
};

export default SignatureQualityNotice;
